import VueCookies from 'js-cookie'
import axios from 'axios'
import router from '@/router/router'
import $const from '@/utils/const'
import store from '@/store/store'
import $http from '@/plugins/axios'
import { actionTypes } from '@/store/store.type'
import { stringify } from 'querystring'

const TokenKey = 'jwToken'
const RefreshToken = 'refreshToken'

const AuthService = {
    getToken () {
        return VueCookies.get(TokenKey)
    },
    setToken (token) {
        return VueCookies.set(TokenKey, token)
    },
    removeToken () {
        return VueCookies.remove(TokenKey)
    },
    getRefreshToken () {
        return VueCookies.get(RefreshToken)
    },
    setRefreshToken (token) {
        return VueCookies.set(RefreshToken, token)
    },
    removeRefreshToken () {
        return VueCookies.remove(RefreshToken)
    },
    // all in one authenticate function for easy use
    signIn () {
        const provider = JSON.parse(sessionStorage.getItem($const.sessionStorageKey.provider))
        switch (store.state.authenticationService) {
            case $const.AuthenticationService.SELF:
                this.signInSelf()
                break
            case $const.AuthenticationService.OPEN_ID:
                this.signInOpenId(provider)
                break
            default:
                router.push('/authentication')
        }
    },
    signOut () {
        const provider = JSON.parse(sessionStorage.getItem($const.sessionStorageKey.provider))
        switch (store.state.authenticationService) {
            case $const.AuthenticationService.SELF:
                this.signOutSelf()
                break
            case $const.AuthenticationService.OPEN_ID:
                this.signOutOpenId(provider)
                break
            default:
                router.push('/authentication')
        }
    },
    // authenticate self service
    signInSelf () {
        router.push('/authentication/self')
    },
    signInSelfToken (email, password) {
        return axios.post(
            process.env.VUE_APP_BASE_API_V4_URL + '/jwt-auth/token/',
            {
                email,
                password
            }
        )
    },
    signOutSelf () {
        router.push('/authentication/self')
    },
    // authenticate open id service
    signInOpenId (provider) {
        const openIdParams = {
            client_id: provider.client_id,
            scope: 'openid+profile+email+phone',
            response_type: 'code',
            redirect_uri: provider.redirect_uri
        }
        const openIdQueryParams = unescape(stringify(openIdParams))
        window.location.href = `${provider.oidc_config.authorization_endpoint}?${openIdQueryParams}`
        // axios.get(process.env.VUE_APP_AUTHORIZATION_BASE + $const.OPEN_ID_CONFIG_PATH).then(result => {
        //     window.location.href = this.createFptIdUrlParams(result.data.authorization_endpoint)
        // })
    },
    signOutOpenId (provider) {
        // sign out back-end
        $http.post('/jwt-auth/logout/', { refresh_token: this.getRefreshToken() }).finally(() => {
            // sign out front-end
            this.removeToken()
            sessionStorage.clear()
            store.commit(actionTypes.user.TOKEN, {
                token: '',
                refresh: ''
            })
            store.commit(actionTypes.user.PROFILE, {})
            // sign out open id
            window.location.href = `${provider.oidc_config.end_session_endpoint}?redirect_uri=${window.location.origin}?provider=${provider.name}`
            // let openIdConfig = store.state.openIdConfig
            // if (openIdConfig.end_session_endpoint) {
            //     window.location.href = this.createFptIdUrlParams(store.state.openIdConfig.end_session_endpoint)
            // } else {
            //     axios.get(process.env.VUE_APP_AUTHORIZATION_BASE + $const.OPEN_ID_CONFIG_PATH).then(result => {
            //         window.location.href = this.createFptIdUrlParams(result.data.end_session_endpoint)
            //     })
            // }
        })
    },
    getAuthenticationSuccessUrl () {
        return `${window.location.origin}/authentication/fpt-id/success/`
    },
    // createFptIdUrlParams (url) {
    //     return $utils.buildUrl({
    //         url,
    //         params: {
    //             client_id: process.env.VUE_APP_AUTHORIZATION_CLIENT_ID,
    //             redirect_uri: this.getAuthenticationSuccessUrl(),
    //             state: Math.random().toString(36).substring(2),
    //             response_type: 'code',
    //             scope: 'openid+profile+email+phone'
    //         }
    //     })
    // },
    async getProvider (provider) {
        const redirectUri = this.getAuthenticationSuccessUrl()
        const oidcEndpoint = process.env[`VUE_APP_${provider.toUpperCase()}_OIDC_ENDPOINT`]
        const clientId = process.env[`VUE_APP_${provider.toUpperCase()}_CLIENT_ID`]
        const oidcCfg = await $http.get(`${oidcEndpoint}/.well-known/openid-configuration`)
        return {
            client_id: clientId,
            redirect_uri: redirectUri,
            oidc_endpoint: oidcEndpoint,
            name: provider,
            oidc_config: oidcCfg.data
        }
    }
}

export default AuthService
